import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  template: `
    <div class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 max-w-sm">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="flex items-start gap-3 px-4 py-3 rounded-lg shadow-lg border animate-slide-in"
          [class.bg-success-50]="toast.type === 'success'"
          [class.border-success-200]="toast.type === 'success'"
          [class.text-success-700]="toast.type === 'success'"
          [class.bg-danger-50]="toast.type === 'error'"
          [class.border-danger-200]="toast.type === 'error'"
          [class.text-danger-700]="toast.type === 'error'"
          [class.bg-warning-50]="toast.type === 'warning'"
          [class.border-warning-200]="toast.type === 'warning'"
          [class.text-warning-700]="toast.type === 'warning'"
          [class.bg-primary-50]="toast.type === 'info'"
          [class.border-primary-200]="toast.type === 'info'"
          [class.text-primary-700]="toast.type === 'info'"
          role="alert">
          <i [class]="toastIcons[toast.type]"></i>
          <span class="text-sm flex-1">{{ toast.message }}</span>
          <button (click)="toastService.dismiss(toast.id)"
            class="text-current opacity-50 hover:opacity-100 transition-opacity ml-2">
            <i class="fa fa-times text-xs"></i>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes slide-in {
      from { transform: translateY(100%); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    .animate-slide-in { animation: slide-in 0.25s ease-out; }
  `]
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);

  readonly toastClasses: Record<string, string> = {
    success: 'bg-success-50 border-success-200 text-success-700',
    error: 'bg-danger-50 border-danger-200 text-danger-700',
    warning: 'bg-warning-50 border-warning-200 text-warning-700',
    info: 'bg-primary-50 border-primary-200 text-primary-700',
  };

  readonly toastIcons: Record<string, string> = {
    success: 'fa fa-check-circle',
    error: 'fa fa-exclamation-circle',
    warning: 'fa fa-exclamation-triangle',
    info: 'fa fa-info-circle',
  };
}
